export default {
  methods: {
    numToString(num, fr = 10) {
      if (!num) return "NA";
      return num.toLocaleString("en-us", {
        maximumFractionDigits: fr,
        useGrouping: false
      });
    },
    handleResponseError: function(error) {
      if (error.response && error.response.data) {
        return this.$notify.error({
          title: "Ошибка",
          message: error.response.data.message
        });
      }
      if (error.message) {
        return this.$notify.error({
          title: "Ошибка",
          message: error.message
        });
      }
      return this.$notify.error({
        title: "Ошибка",
        message: "Что-то пошло не так, попробуйте еще раз!"
      });
    },
    timeAgo: function(ms) {
      const msPerMinute = 60 * 1000;
      const msPerHour = msPerMinute * 60;
      const msPerDay = msPerHour * 24;
      const msPerMonth = msPerDay * 30;
      const msPerYear = msPerDay * 365;

      if (ms < msPerMinute) {
        return Math.round(ms / 1000) + " сек. назад";
      } else if (ms < msPerHour) {
        return Math.round(ms / msPerMinute) + " мин. назад";
      } else if (ms < msPerDay) {
        return Math.round(ms / msPerHour) + " час. назад";
      } else if (ms < msPerMonth) {
        return "примерно " + Math.round(ms / msPerDay) + " д. назад";
      } else if (ms < msPerYear) {
        return "примерно " + Math.round(ms / msPerMonth) + " мес. назад";
      } else {
        return "примерно " + Math.round(ms / msPerYear) + " г. назад";
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/mixins.js